import { useEffect, useState } from "react";

const KEY = "ad-cookie-consent";
const EVT = "ad-consent-change";

export const getConsent = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY))?.value ?? null;
  } catch {
    return null;
  }
};

export const setConsent = (value) => {
  localStorage.setItem(KEY, JSON.stringify({ value, date: new Date().toISOString() }));
  window.dispatchEvent(new Event(EVT));
};

export const resetConsent = () => {
  localStorage.removeItem(KEY);
  window.dispatchEvent(new Event(EVT));
};

export const useConsent = () => {
  const [consent, setState] = useState(getConsent);
  useEffect(() => {
    const onChange = () => setState(getConsent());
    window.addEventListener(EVT, onChange);
    return () => window.removeEventListener(EVT, onChange);
  }, []);
  return consent;
};
